// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__yma0H","title":"styles_title__P2NMt","regularTitle":"styles_regularTitle__dK8pd"};